<transition :css="false">
    <m-chip-add v-if="isModeAdd"
                :disabled="disabled"
                :size="size"
                @click="emitClick"
                @add="emitAdd">
        <slot></slot>
    </m-chip-add>
    <m-chip-delete v-if="isModeDelete"
                   :disabled="disabled"
                   :size="size"
                   @click="emitClick"
                   @delete="emitDelete">
        <slot></slot>
    </m-chip-delete>
</transition>
